import React, {FC, FormEvent} from 'react'

import cn from 'classnames/bind'
import {observer} from 'mobx-react-lite'

import FieldsW2Information from 'components/blocks/forms/FieldsW2Information'
import FormHeader from 'components/blocks/forms/FormHeader'
import FormW2Finish from 'components/blocks/forms/FormW2Finish'
import FormW2Invoice from 'components/blocks/forms/FormW2Invoice'
import FormTips from 'components/blocks/FormTips'
import Button from 'components/elements/Button'
import {Col, Container, Row} from 'components/elements/grid'
import {onScrollToTop} from 'src/utils'
import {useW2Store} from 'src/utils/contexts/RootStore.context'

import s from './FormW2.module.scss'

const cx = cn.bind(s)

interface IFormW2Props {
	togglePreview: () => void
	className?: string
}

const FormW2: FC<IFormW2Props> = ({togglePreview, className}) => {
	const w2Store = useW2Store()
	const onSubmit = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault()
		togglePreview()
		onScrollToTop()
	}

	return (
		<form className={cx('wrapper', className)} onSubmit={(e) => onSubmit(e)}>
			<FormHeader
				title="1. Information"
				button={
					<Button disabled={!!w2Store.errorMessage} type="submit" size="small" variant="secondary">
						Preview
					</Button>
				}
			/>
			<Container>
				<FormTips className={cx('tips')} />
				<FieldsW2Information className={cx('information')} />
			</Container>
			<Container>
				<Row>
					<Col xl={{offset: 1, span: 10}} className={cx('scrollable')}>
						<h2 className={cx('header__title', 'step__title')}>2. Invoice</h2>
					</Col>
				</Row>
				<Row>
					<Col xl={{offset: 1, span: 10}} className={cx('scrollable')}>
						<FormW2Invoice className={cx('invoice')} />
					</Col>
				</Row>
			</Container>
			<Container>
				<Row>
					<Col>
						<section className={cx('finish')}>
							<h2 className={cx('header__title', 'step__title')}>3. Finish</h2>
							<FormW2Finish />
						</section>
					</Col>
				</Row>
			</Container>
		</form>
	)
}

FormW2.displayName = 'FormW2'

export default observer(FormW2)
